import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/7c680545/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const Caption = makeShortcode("Caption");
const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <PageDescription mdxType="PageDescription">
      <p>{`Editing is making changes to a resource that already exists in the system.
Updating and editing should use the same behavior as when the resource is created. This should only vary in situations where the number of editable fields is significantly smaller or larger than during creation, or the context of current settings is required.`}</p>
    </PageDescription>
    <h4 {...{
      "id": "status"
    }}>{`Status:`}</h4>
    <p><a parentName="p" {...{
        "href": "/experimental/overview/"
      }}>{`Experimental`}</a></p>
    <h4 {...{
      "id": "maintainers"
    }}>{`Maintainers:`}</h4>
    <p><a parentName="p" {...{
        "href": "https://github.com/vikkipaterson"
      }}>{`Vikki Paterson`}</a>{`, `}<a parentName="p" {...{
        "href": "https://github.com/chloepoulterdesign"
      }}>{`Chloe Poulter`}</a></p>
    <AnchorLinks mdxType="AnchorLinks">
  <AnchorLink mdxType="AnchorLink">Low-impact edit</AnchorLink>
  <AnchorLink mdxType="AnchorLink">High-impact edit</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Optional extras</AnchorLink>
    </AnchorLinks>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "60.670731707317074%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsSAAALEgHS3X78AAAB2UlEQVQoz52TzWrqUBSF+3TtsCAOilr6BJUrnVz/TTTG34qJQqVO+wDiAxQ6CKXSjkoV7UAFR0WuSowVieuevblpI7Z30MDinHDW+fY6OycH2+0W7ofeHX33uD1uL40HNJlOpwiHw8hms4hGozyPRCL/leOhMRaLYTabMZSBw+EQHo8HqVSKgclkEolEghWPx3mDW86as077doDj8Rh+v58TSpIEWZYZ3G630e120ev1MBgM0O/3eaxWqwxOp9PsVRQF8/n8EzgajRhYqVSgqioKhQKDO50O92Wz2cC2bRa9N5tNhpEvl8shn8/vJiRgIBDgyrRYKpWQyWRgGAZM02QtrZXQO8ylhWsBpNMUi0WGkvaAlLBcLnN8qkp9pITr9RpLAXlf/sHafANsE83rhjiBLHwqg+lUe0Cfz8eVqCeUjhrearXw+PSEzsM9jOcp7l5s3L8CFe1KfIiE8CkfPfwyIR2BekNAqhoMBkUrTnF2eoLj8xscXRg4/HWLiHQJVRGFBYi8lHLv2ni9XoZQMroGJK4uNtDGbDoGVf4tFIaUSn54qDX0AXeAk8kEoVAIjUYDmqahVquxdF13qQZNr7P0f+uOp16vY7FYfALpOliWhdVq9WM5v99fULbsbaoc8e0AAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Contextual image of an edit modal",
        "title": "Contextual image of an edit modal",
        "src": "/static/a86b9c340588c7827eb1e713737bf7c9/fb070/01.png",
        "srcSet": ["/static/a86b9c340588c7827eb1e713737bf7c9/d6747/01.png 288w", "/static/a86b9c340588c7827eb1e713737bf7c9/09548/01.png 576w", "/static/a86b9c340588c7827eb1e713737bf7c9/fb070/01.png 1152w", "/static/a86b9c340588c7827eb1e713737bf7c9/e8e91/01.png 1312w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <Caption mdxType="Caption">Example of an edit modal in context</Caption>
    <h2 {...{
      "id": "low-impact-edit"
    }}>{`Low-impact edit`}</h2>
    <p>{`For low-impact edits, allow editing with no warning. This approach is typically used when editing doesn’t have a wider impact.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "59.83231707317073%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsSAAALEgHS3X78AAAA1ElEQVQoz82T2QqEMAxF/f+PLLQuBanWXcElMzcQqdTBh5mHKVxSk3iaWzSh9zqOg36xwEkEhvitsE7gsizkvaeu62gcx0dN03TRvu8xsG1bBobq+z7Koa+ua3LOUVmWrG3brsCmaUhrTdZayrKMVRQFGWMoz3NWmqacQ0QdUSnFPeu6XoHzPLNlTAS4TIu9TAVJPZwWMbIMIIrDMJxWIYEIAHXpg2VMjhhZDoFy6h1QcuirqorvD8+3QFiRF0JLkgv3j5ZxAi5W4ifd1ZE7v8O//1NeHJWnSpZk8SwAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Example of an edit button in a table",
            "title": "Example of an edit button in a table",
            "src": "/static/3b12a3e83c62fe0d5377d0df8353e63a/fb070/02.png",
            "srcSet": ["/static/3b12a3e83c62fe0d5377d0df8353e63a/d6747/02.png 288w", "/static/3b12a3e83c62fe0d5377d0df8353e63a/09548/02.png 576w", "/static/3b12a3e83c62fe0d5377d0df8353e63a/fb070/02.png 1152w", "/static/3b12a3e83c62fe0d5377d0df8353e63a/e8e91/02.png 1312w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Example of an edit button in a table</Caption>
      </Column>
    </Row>
    <h3 {...{
      "id": "modal"
    }}>{`Modal`}</h3>
    <p>{`If an object was created in a modal, its editable fields can be made available in a modal. A modal can also be used where a small subset of fields are editable.
If enough fields are editable to require scrolling, use a side-panel or full-page edit dialog instead.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "59.83231707317073%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsSAAALEgHS3X78AAABCElEQVQoz52TTU7DMBCFeyw2bLkBK0oFrDkCEuEEPV8MYhHRlkysNI3z44g4D08iQ5OWqsbSkzPK05eZ53iGyeq6bvS8X5/yujU7ZpiCXD3VMegB0BnSNEUcx5BSoizLA3kDsyzroVVVoa5raK1/xLUxxg+Y5zmUUmiaZgRzwLM7dHtRFD1wCnP618icH4MLm5nqP/Ar4wvk7PhQBn1CxitIWmG3JXQtd2j8Ro6iCGEYQghh91eISOFt3UB8aLxvNNrWI0M+iCAIcDOf4/5ugduHR1w9Ey5fgIunL1wvDfJq8JpzO+RfhoiQJARKJDbb1gpYW9HOgvqJOaITN+Wv67T3dqTBOvZ/A7l3pLhT5JkFAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Example of a low consequence edit action in a modal",
            "title": "Example of a low consequence edit action in a modal",
            "src": "/static/31120f360a3950c04f47a5bc8f5e4653/fb070/03.png",
            "srcSet": ["/static/31120f360a3950c04f47a5bc8f5e4653/d6747/03.png 288w", "/static/31120f360a3950c04f47a5bc8f5e4653/09548/03.png 576w", "/static/31120f360a3950c04f47a5bc8f5e4653/fb070/03.png 1152w", "/static/31120f360a3950c04f47a5bc8f5e4653/e8e91/03.png 1312w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Example of a low consequence edit action in a modal</Caption>
      </Column>
    </Row>
    <h3 {...{
      "id": "side-panel"
    }}>{`Side-panel`}</h3>
    <p>{`If an object was created in a side panel, its editable fields can be made available in a side panel. A side panel can also be used where context in the main view of the screen is useful in the editing flow.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "60.670731707317074%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsSAAALEgHS3X78AAABmklEQVQoz4WTy2rCQBSG+4ziSn0Jlyp4v0UJ4g0VuinU0k237Tt0L6IgqCQ2YiJGqRJN/Os5bVITIgb+nDPMnC9n/pk8nM9nXD80vqfj8ejIMAyWzXmgl6ZpiMViKBaLSCQSnMfjcRbl9tiO9Xod7Xab1el00O12sdvt/oHT6RSBQADpdJqBqVQKyWTSV5lMBqPRCOv1mhsh0Ha75W4d4Hw+Rzgc5g6pgETwXC7H0c7pQ/l8HovFAqZpOtslGI0d4Gw2Y2CtVkOpVEK5XGYJguDKaa5SqUCSJIbs93scDgd/YCQSYW+okIpuSRRFtoi2qus6NpsN574d0uJCocBb94q6ozmCDgYDTCYTjMdjDIdDKIoCy7LcwFAoxIuz2Sz7dUsEXS6XfE3Iv9PpxN35dlitVrmIjPeKQBSpU1VVudiie/kXXUDyJBgM8mK6GvbJekWnTDsg37yPCyjLMqLRKHq9HhqNBlqt1k01m00891/w2n/C49snhA9AfDegf18ByVD7CtwTrVut1IuPCr5WOiTNhKxdfLR+f70foIcDXW9mXY8AAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Example of a low-impact edit action in a side panel",
            "title": "Example of a low-impact edit action in a side panel",
            "src": "/static/a00c44ed733301d9ebce168e9cb91bdc/fb070/04.png",
            "srcSet": ["/static/a00c44ed733301d9ebce168e9cb91bdc/d6747/04.png 288w", "/static/a00c44ed733301d9ebce168e9cb91bdc/09548/04.png 576w", "/static/a00c44ed733301d9ebce168e9cb91bdc/fb070/04.png 1152w", "/static/a00c44ed733301d9ebce168e9cb91bdc/e8e91/04.png 1312w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Example of a low impact edit action in a side panel</Caption>
      </Column>
    </Row>
    <h2 {...{
      "id": "high-impact-edit"
    }}>{`High-impact edit`}</h2>
    <p>{`Warn the user of the consequences of editing. This pattern is typically used when editing has a wider impact.
Inform users of the likely consequences of the edit to their system, and inform them that editing cannot be undone. Include a warning stage.`}</p>
    <h3 {...{
      "id": "modal-1"
    }}>{`Modal`}</h3>
    <p>{`A high-impact edit action of only a few fields can use a danger modal. A second confirm edit modal should also be inserted before the changes are saved. If desired, the confirmation modal can include a `}<a parentName="p" {...{
        "href": "#summary-of-changes"
      }}>{`summary of changes`}</a>{`.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "59.83231707317073%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsSAAALEgHS3X78AAABmElEQVQoz62Ty07CQBSGeTW3JrrTlcYEwtKVLoxGWYAbEzcaNSkm+CAuWbkRUSlUjDEp5dYLlt4opb9zBjvoBjFxki/pTM9858yZNhXHMf5rkCtFD5PJBEEQcMIwxHg8FtA8iiIeMxqNxDwhiaH3NLiQFlRVRbfbhW3bcBxHQHMSDYdDKIqCZrPJ44x+n2MPBviwLIQsRggpk8UWSUCbk2oJ3/dF1X0m6PV6ME0Tpuei7bKkbL9HjumZZ0LP87iAhN8hIY1KpQJJknBTKqHIuJOuYV4WoZ1fQTs9g6+8/KyQjkSbExFVRSTCcrmMXC6H40IBh/k8bg9yMPeO0N7dR3t7B/79w0xIx9F1HQPWD9d14VL/WAJqASWi6v98y4Zh8ItptVrQNA1ap8MZDG2M2QniSczjEuKEiIiQfH7ilqnZdHsdRp/hmRbHNUwEjiMqmIcQNhoNZLNZZNJpbGTSONncgrq6jreVNbwuLUO/kKbCr29t3uBC6pssy6gzanUZ77UaRtUnBI/P8CtVhKomKvxVuOivt2jcJ7TzjQt2ZsxFAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Example of a high-impact editing modal and consequent warning modal",
            "title": "Example of a high-impact editing modal and consequent warning modal",
            "src": "/static/b120013ac62a0706f7ed48e7cf85260d/fb070/05.png",
            "srcSet": ["/static/b120013ac62a0706f7ed48e7cf85260d/d6747/05.png 288w", "/static/b120013ac62a0706f7ed48e7cf85260d/09548/05.png 576w", "/static/b120013ac62a0706f7ed48e7cf85260d/fb070/05.png 1152w", "/static/b120013ac62a0706f7ed48e7cf85260d/e8e91/05.png 1312w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">
  Example of a high-impact editing modal and consequent warning modal
        </Caption>
      </Column>
    </Row>
    <h3 {...{
      "id": "side-panel-1"
    }}>{`Side-panel`}</h3>
    <p>{`If an object was created in a side panel, or there are too many editable fields for a modal, a slide-over panel can be used.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "60.746951219512205%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsSAAALEgHS3X78AAABmElEQVQoz42S2WoCQRBF/UbxSf0NcUHcdxHxQR2CIZAE44fkF0QUH1QUdQaXQdO4Td90FagRx2DDnWqYrkPVrXJIKXE+lmU9pf1+j91ud6Mzx0GfxWIBv9+PdDqNUCiEQCDwUMFgEJVKBbVaDdVqFfV6HZqmYbPZXIGDwQBOpxPxeBzhcBjRaNRWkUiE3/R6PaxWKyyXS2y3W4YdDocrcDQawePxIJPJcAIpFoshmUxyPN8JmkqlMJlMcDweL+0S7HQ6XYHD4ZCB5XIZ2WwWuVyOlc/n7+6FQgHj8ZghQojHQK/Xy95QIiU9UqlUYouoTdM0sV6v+W5bIT2mwVDrdqJ/BG232+j3++h2u+h0OphOpzz9G6Db7ebHiUSC/Xokguq6zsnUKnlJ1dlWWCwWL0l2ooGQx7RmdKQlL/EvUCpPpMvlkqotqVZDqmneSU2ao+pAqpUh0o0UkCNXOJvN4PP50Gg0eGFpWf/TV7OJj1YL3++fMLVXGC9vOG1/LhUKZahQ439aqmWhG4YwdUPs5nMlXagSBbF+AbGpAsTm0mN6AAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Example of a high-impact edit action in a side panel",
            "title": "Example of a high-impact edit action in a side panel",
            "src": "/static/487fc5ce9cdcf900c70e32fcf19fc3a7/fb070/06.png",
            "srcSet": ["/static/487fc5ce9cdcf900c70e32fcf19fc3a7/d6747/06.png 288w", "/static/487fc5ce9cdcf900c70e32fcf19fc3a7/09548/06.png 576w", "/static/487fc5ce9cdcf900c70e32fcf19fc3a7/fb070/06.png 1152w", "/static/487fc5ce9cdcf900c70e32fcf19fc3a7/e8e91/06.png 1312w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Example of a high-impact edit action in a side panel</Caption>
      </Column>
    </Row>
    <p>{`High-impact side panel edits should also warn the user of destructive edits with a warning before changes are saved.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "60.624523990860624%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsSAAALEgHS3X78AAABbUlEQVQoz41S22rCUBDsP4pP6lf4pIL3OyKKYrCFgtS2/9GP8ANUSCJqig9eEj1TZ9ujpjbVhcnuJtnJbM48KKU8fIeSi1I34boudrudD7zPeDjCcxwHyWRSlctlpFIpJBIJ9gLWute53W7DMAz0ej3J/X4fq9XqTDgejxEKhVQ2mxXCTCYjSKfTp1r3uVwOo9EIlmXBNE1QDMk8zzsTTqdTRKNRVSqVZIAgeaFQ8NU6k2i/38vqOtifCCeTiRA2m01UKhVUq1VBrVa7quv1OpbLJfT/1vmKMBaLqVarJYMcCkKj0cBisZDhw+EQTEiFfJlr83CCQJXz+fw2YSQSUVSXz+flPwWBH7yLkAq5EoeKxeIVSMRMlZeE4s1j9hHSNuFwWHxIe/A0/wKfcQNa5Xf4CGmDeDyuaNBOp4Nut/svXodDDN7f8DF4gWM8wX58hntpbMper9dqs9ngHnBlezbDpz3D1rSwtWyoH4VfIo8GM1JPnwUAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Example of a warning screen in a side panel before a user saves changes",
            "title": "Example of a warning screen in a side panel before a user saves changes",
            "src": "/static/04c9c587a613d1b2140d57baeac7abee/fb070/07.png",
            "srcSet": ["/static/04c9c587a613d1b2140d57baeac7abee/d6747/07.png 288w", "/static/04c9c587a613d1b2140d57baeac7abee/09548/07.png 576w", "/static/04c9c587a613d1b2140d57baeac7abee/fb070/07.png 1152w", "/static/04c9c587a613d1b2140d57baeac7abee/c6a2b/07.png 1313w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">
  Example of a warning screen in a side panel before a user saves changes
        </Caption>
      </Column>
    </Row>
    <h3 {...{
      "id": "full-page"
    }}>{`Full page`}</h3>
    <p>{`When an object was created in a full-page flow, or the volume of editable fields is high, use a full-page edit dialog.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "60.670731707317074%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsSAAALEgHS3X78AAABhUlEQVQoz52TXU7CQBSFXaFSIPyUVfgk7sAHl2LimyGuwZgCxQg8yU+Itva/QJH2OGfKhAImRpucznR655tz723PIK4sy+D7HmzbhuO4uVxXrAU/iu+kHAeflg3P8ySD1xlvX5sN2tdXqDV0VGt1lLQyypUqGk39RE1dh1ap4KKkQas3cN5q4bLdRrJe74FZmmI4GuPZ6KHX7cIwDPT7fQwGg71ME+ZOnL+Mhug9dPB0c4vXziPSPNUcmAq37x82JpM3mfZsNoNlWVitVlgul1KcJ0mSS7hJhIl4OIZ3d4+wbyI7AAqiJWpBWBiGcqTcXZ0o1ikIAinf96UCcUgo9gfigHS7LaQsyNxMRVEoxziOpZu1CKbokGtRFEkoDw4I5UFiTNN0D+SDDNgF0g0dqFRV6sdAtYf6Fcg0CVBAzvnuX8CiO9UU9fxnIDcsFgvR8Yns9nQ6xXw+l2sU3StYUSdA1T2O/GRUl6ljiIordvwAyC6rOqniq++u2OVic1QZVKz69b4BgG96g9Xkez4AAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Example of a full-page edit view",
            "title": "Example of a full-page edit view",
            "src": "/static/871858dcf4f28df51c63b442fbebc021/fb070/08.png",
            "srcSet": ["/static/871858dcf4f28df51c63b442fbebc021/d6747/08.png 288w", "/static/871858dcf4f28df51c63b442fbebc021/09548/08.png 576w", "/static/871858dcf4f28df51c63b442fbebc021/fb070/08.png 1152w", "/static/871858dcf4f28df51c63b442fbebc021/e8e91/08.png 1312w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Example of a full-page edit view</Caption>
      </Column>
    </Row>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "60.670731707317074%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsSAAALEgHS3X78AAACFklEQVQoz41TW2saURDOP+tDtFHSJBQKJU8phEAr7UNDwQv2qRZddXXXS1wf6mWNeRcpRKUPfUhX+ye8gIKFCF6bZtWvM4dak2JpF76dOed8883MGc4W6Fsul5hOJxiORhiNxwLj8QTT2WwjxpPJLw5xh0NMaM0a/G3xz7w18fKVA5aHO9ix2bFttcJK/qO9fcLeH9gXZ9sWC6x2Ox7YbDhxOPDj5mYtOJ/PoapxnJ6+gcvlgtPpFNbj8WyG2w2P1wv38xd4bd9FxPsW5mJxV3CBXF7He58PkUgUUjAIWZahKAqtI8JnG41GxV4ykcCZpiHxzofw8QnOFRXzuy1zhblcHpIkIRaLIRQKUcUqSqUSyuUyKpUKatUqPtVqqF5eIplMigRqMgGZfP3igq7tdi24IEFd14VQPB5HOBxGJpNBv9/H4PpaDGHwfYYZcadUSSabFVVzcpliONY0zfsVFovFNYlsKpWCYRgw6nU0rq7wzWhgVP+KwZcGPlC7MrW/4hYKhb8Lcqt8T9z+s6MjPD08xDHh48ETfLYdoLb7GGeBAKLxGGLE/acgZ2VBbl2jStLpNLS0BkUgjYiWgkJCKnHU/xFkoSBNOUBVMPx+v7Ah2gtJQSjcKgsSODkPZ6NgPp8XgUzgdhk8pBU42Qo8NAb7zMvSkO4J8rPp9XpoNptot9totVrodDobsTpnsM8x3W7399P7CevP4AZWBgudAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Example of a modal warning users of the consequences of saving after a full-page edit",
            "title": "Example of a modal warning users of the consequences of saving after a full-page edit",
            "src": "/static/f9fd128dafa71411f6ab64d5cc075a84/fb070/09.png",
            "srcSet": ["/static/f9fd128dafa71411f6ab64d5cc075a84/d6747/09.png 288w", "/static/f9fd128dafa71411f6ab64d5cc075a84/09548/09.png 576w", "/static/f9fd128dafa71411f6ab64d5cc075a84/fb070/09.png 1152w", "/static/f9fd128dafa71411f6ab64d5cc075a84/e8e91/09.png 1312w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">
  Example of a modal warning users of the consequences of saving after a
  full-page edit
        </Caption>
      </Column>
    </Row>
    <h2 {...{
      "id": "optional-extras"
    }}>{`Optional extras`}</h2>
    <h3 {...{
      "id": "summary-of-changes"
    }}>{`Summary of changes`}</h3>
    <p>{`Adding a summary of changes to the warning stage of a high-impact flow can help the user manage and understand all of the changes they have made.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "59.83231707317073%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsSAAALEgHS3X78AAABFklEQVQoz5WT22qDQBCG83a9KfSivSmkNHiX5/ABS5vWQ0EFFfF82FVbD/Gvs9RchIS4Az/DLD8fM8PsBhdimiasiUu+zblhMfV9j67rMAwDxnE8iWrS4juHXgVGUQTLsuB5HvI8R5ZlInPOhaSBQRDANE3Ytg3HcU7wtm2FpIFxHMN1XZEJTjlJEtF5URTyQBrR932EYSg6S9NUvBGURpcGMsZEJ7QvgpHq//2xqloPXKJpGtR1LfZVzYBiFp/fFkkBKZdlKcZbRmVz5nPN4gQ1jXw8rgfSDaqqipftFjtFwf51h7fHZ3j3T7DvHuApe4yMy3VIp6JpGnTDwLeugx++0H184uf9gF/DxDQf+U2gzLe75v0DwWGe3tPkAhUAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Example of a summary of changes in a modal",
            "title": "Example of a summary of changes in a modal",
            "src": "/static/17f933e38179cbed3ce3725cb7dced2f/fb070/11.png",
            "srcSet": ["/static/17f933e38179cbed3ce3725cb7dced2f/d6747/11.png 288w", "/static/17f933e38179cbed3ce3725cb7dced2f/09548/11.png 576w", "/static/17f933e38179cbed3ce3725cb7dced2f/fb070/11.png 1152w", "/static/17f933e38179cbed3ce3725cb7dced2f/e8e91/11.png 1312w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Example of a summary of changes in a modal</Caption>
      </Column>
    </Row>
    <h3 {...{
      "id": "non-editable-fields"
    }}>{`Non-editable fields`}</h3>
    <p>{`When a small number of fields are not editable, display their set value in a disabled field.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "59.83231707317073%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsSAAALEgHS3X78AAAAr0lEQVQoz8WT2QqEMAxF/f+Ps/W1H2Drk+DSzSXDDVjq4AzTvkzgkCjXaxLaht7iPM+Uv5Fr82joIZ6Ev2qaT8IYI7PvOx3HcaOow0tkraVxHDl77xPOOQohlBvi43Vd2RD5qkGVIQzmeU5mlyF+hDVUjTxNE+9x27YEnqs6hFnf92SMYbTWDOplWcoNh2Ggtm2p6zqSUjJCCFJK8SqKDTEWOsl3CPAeo///YNdevRfXdLJR6Xo8kQAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Example of a single non-editable field",
            "title": "Example of a single non-editable field",
            "src": "/static/6478c049c8ad22a05494017ba189b75a/fb070/10.png",
            "srcSet": ["/static/6478c049c8ad22a05494017ba189b75a/d6747/10.png 288w", "/static/6478c049c8ad22a05494017ba189b75a/09548/10.png 576w", "/static/6478c049c8ad22a05494017ba189b75a/fb070/10.png 1152w", "/static/6478c049c8ad22a05494017ba189b75a/e8e91/10.png 1312w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Example of a single non-editable field</Caption>
      </Column>
    </Row>
    <p>{`Where a majority of variables are not editable, consider using an option that will display only editable fields. In a small number of cases, make individual variables editable in modals.`}</p>
    <h3 {...{
      "id": "success-notifications"
    }}>{`Success notifications`}</h3>
    <p>{`An optional success notification can be used to confirm that the user’s changes have been saved.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "59.83231707317073%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsSAAALEgHS3X78AAAA4ElEQVQoz61S2QrCMBD0/3/JF0FRxKtYtfGssUZF61Wvmm0zRkURKRjRDcPsZDfDBjaFP0fqVSilnmyC1zeJhu+mSEJC78cJYxXfdcKXIl27HqMJH8XhTiDjV2DNGSrTBsoTDWGjpNELBdiRY0WBuWE/8JDf2sjyMtIsd+O8sFDQcEKOZjjEQm7MDV09ISMP1rqN4sxGTXPjMEDz6KJDYzg0gk9bc0O+n8I5cbQCF/VVF5bPUJ07qC876EmBduhhKb8wpDjCmSRkTDqnmyYVPe+viHT+1dqYhPHa/HWxf40LJbWs/uLqtEsAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Example of a successful editing toast notification",
            "title": "Example of a successful editing toast notification",
            "src": "/static/c0e3754c81ee165f69df4bc3b021e325/fb070/12.png",
            "srcSet": ["/static/c0e3754c81ee165f69df4bc3b021e325/d6747/12.png 288w", "/static/c0e3754c81ee165f69df4bc3b021e325/09548/12.png 576w", "/static/c0e3754c81ee165f69df4bc3b021e325/fb070/12.png 1152w", "/static/c0e3754c81ee165f69df4bc3b021e325/e8e91/12.png 1312w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Example of a successful editing toast notification</Caption>
      </Column>
    </Row>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      